import React from "react";
import { Icon } from "../Icon";
import { FUNDING } from "../content";
import { CtaBand, FaqList, FlowLine, PageHero, SectionHead, useSeo } from "../ui";

export default function Funding() {
  useSeo({
    title: "정부지원사업 연계 — 창업 시제품 개발 · 사업계획서 기술 파트 | I.META",
    description:
      "창업패키지·아이디어 공모전·시제품 제작 지원사업의 개발 예산으로 I.META와 진행할 수 있습니다. 사업계획서 기술 파트 작성 지원, 협약 기간 내 시제품 납품, 결과보고서 기술 자료, 양산 연계. 창업 시제품, 광주 개발업체.",
    path: "/funding",
  });

  return (
    <>
      <PageHero kicker="GOVERNMENT FUNDING · 정부지원사업 연계" title={FUNDING.headline} desc={FUNDING.lead} />

      {FUNDING.notice && (
        <section className="section section--tight">
          <div className="notice-box" role="note">{FUNDING.notice}</div>
        </section>
      )}

      <section className="section section--tight">
        <div className="grid grid--2 fund-cols">
          <div className="contact__panel">
            <h2 className="contact__panel-title">대상</h2>
            <ul className="checklist">
              {FUNDING.targets.map((t) => (
                <li key={t}>
                  <Icon.Check width="15" height="15" aria-hidden="true" focusable="false" />
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="contact__panel">
            <h2 className="contact__panel-title">제공 내용</h2>
            <ul className="checklist">
              {FUNDING.offers.map((o) => (
                <li key={o}>
                  <Icon.Check width="15" height="15" aria-hidden="true" focusable="false" />
                  <span>{o}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="section">
        <SectionHead kicker="FLOW" title="진행 흐름" />
        <FlowLine items={FUNDING.flow} numbered />
      </section>

      <section id="faq" className="section">
        <SectionHead kicker="FAQ" title="자주 묻는 질문" />
        <FaqList items={FUNDING.faq} />
        <p className="note-line">※ {FUNDING.disclaimer}</p>
      </section>

      <CtaBand to="/contact?gov=1" />
    </>
  );
}
